import {IArticleCategory} from "../../app/interfaces/response/article_category_list";

export const getIsCategorySlug = (slug: string, categoryList?: IArticleCategory[]) => {
    return Boolean(categoryList?.some((category) => category.slug === slug));
};
